/*!
 * Flex Slider settings
 */
var $ = require('jquery');

$(window).on('load', function () {
  var hpSlider = $('.js_arrSlider');
  if (hpSlider.length > 0) {
    hpSlider.flexslider({
      animation: "slide",
      animationLoop: true,
      pauseOnHover: false,
      itemWidth: 100,
      itemMargin: 1,
      minItems: 1,          // use function to pull in initial value
      maxItems: 1,          // use function to pull in initial value
      prevText: "Předchozí",           //String: Set the text for the "previous" directionNav item
      nextText: "Další"
    });
  }
});



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/flexslider-settings.js